import "./Home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsArrowRight, BsArrowLeft , BsDot} from "react-icons/bs";
import { useRef } from 'react';
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import introVideo from "../videos/Home-banner.mp4";

export const Home=()=>{

  const slider01Ref = useRef(null);

  const slider02Ref = useRef(null);

  const bannerRef = useRef(null);

  var banner_slider_settings = {
    className: "homepage-banner-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 2.7,
    slidesToScroll: 1,
    arrows: false
  };


  var slider01_settings = {
    className: "homepage-advance-to-healthier-lifestyle-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <Slider01NextArrow />,
    prevArrow: <Slider01PrevArrow />,
  };

   var slider02_settings = {
     className: "homepage-testimonial-slider-component",
     dots: false,
     infinite: true,
     speed: 500,
     autoplay: false,
     autoplaySpeed: 1500,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: true,
     nextArrow: <Slider02NextArrow />,
     prevArrow: <Slider02PrevArrow />,
   }


  const handleSlider_01_NextClick = () => {
    slider01Ref.current.slickNext();
  };

function Slider01NextArrow() {
  return (
    <BsArrowRight
      className="slider01-nextarrow"
      onClick={handleSlider_01_NextClick}
    />
  );
}

  const handleSlider_01_PrevClick = () => {
    slider01Ref.current.slickPrev();
  };

  function Slider01PrevArrow() {
    return (
      <BsArrowLeft
        className="slider01-prevarrow"
        onClick={handleSlider_01_PrevClick}
      />
    );
  }

  function Slider02NextArrow() {
    return (
      <BsArrowRight
        className="slider02-nextarrow"
        onClick={handleSlider_02_NextClick}
      />
    );
  }

function Slider02PrevArrow() {
  return (
    <BsArrowLeft
      className="slider02-prevarrow"
      onClick={handleSlider_02_PrevClick}
    />
  );
}

  const handleSlider_02_NextClick = () => {
    slider02Ref.current.slickNext();
  };

 const handleSlider_02_PrevClick = () => {
   slider02Ref.current.slickPrev();
 };

// function bannerNextArrow(){
//   return (
//     <BsArrowRight className="banner-nextarrow" onClick={banner_NextClick} />
//   );
// }
 
//  function bannerPrevArrow() {
//    return (
//      <BsArrowLeft className="banner-prevarrow" onClick={banner_PrevClick} />
//    );
//  }

// const banner_NextClick = () => {
//     bannerRef.current.slickNext();
//   };

//  const banner_PrevClick = () => {
//    bannerRef.current.slickPrev();
//  };



    return (
      <div id="Homepage-main-wrapper">
        <div id="Homepage-banner-section-wrap">
          <div id="Homepage-banner-section-media-wrap">
            <Video autoplay loop id="banner-video">
              <source src={introVideo} type="video/webm" />
            </Video>
          </div>
          <div id="Homepage-banner-section-text-wrap">
            <div id="Homepage-banner-section-text-desktop-wrap">
              <div id="Homepage-banner-section-text-01">Limitless luxury</div>
              <div id="Homepage-banner-section-text-02">
                in the heart of Vihari
              </div>
            </div>
            <div id="Homepage-banner-section-text-03">
              10 years of experience
            </div>
          </div>

          <div id="homepage-banner-section-slider-wrap">
            <Slider ref={bannerRef} {...banner_slider_settings}>
              <div className="homepage-banner-section-slider-img-wrap">
                <img src="./Oryza-img/oryza01.JPG" alt="" />
              </div>

              <div className="homepage-banner-section-slider-img-wrap">
                <img src="./Oryza-img/oryza02.jpeg" alt="" />
              </div>

              <div className="homepage-banner-section-slider-img-wrap">
                <img src="./Oryza-img/oryza03.jpeg" alt="" />
              </div>
            </Slider>
          </div>
        </div>
        <div id="Homepage-journey-to-perfection-wrap">
          <div id="Homepage-journey-to-perfection-title">
            The Journey To Perfection - Vihari Projects
          </div>
          <div id="Homepage-journey-to-perfection-content-para-01">
            We have been a key player in the real estate market for more than
            ten years. Due to our significant expertise and thorough
            comprehension of the real estate dynamic, our brand is synonymous
            with dependability and trustworthiness.
          </div>
          <div id="Homepage-journey-to-perfection-content-para-02">
            The Vihari Group is well known for its commitment to its customers.
            We are adamant that all procedures and rules necessary for a secure
            acquisition of our properties be followed.
          </div>
          <div id="Homepage-journey-to-perfection-content-para-02">
            Farmlands and plots owned by the partnership have all acquired
            TS-RERA, DTCP, and HMDA approval. Time value is very important to
            us. In order to expedite the procedures involved in purchasing
            properties, we finish our work on time.
          </div>
          <div id="homepage-journey-to-perfection-background-image-fill-wrap">
            <img
              src="./Home-img/project-bg01.png"
              alt=""
              id="homepage-journey-to-perfection-background-image-fill"
            />
          </div>
        </div>

        <div id="homepage-investive-realestate-oryza-main-wrap">
          <div id="homepage-investive-realestate-background-image-fill-wrap">
            <img
              src="./Home-img/project-bg02.jpeg"
              alt=""
              id="homepage-investive-realestate-background-image-fill"
            />
          </div>
          <div id="homepage-investive-realestate-oryza-text-content-wrap">
            <div id="homepage-investive-realestate-oryza-main-headline">
              We are a investive real estate developer - Oryza Farmlands
            </div>
            <div id="homepage-investive-realestate-oryza-content-para-01">
              Oryza Farmland is the ideal location to blend nature with a
              Residence. About 30-minute drive separates the community from
              Gachibowli and the city.
            </div>
            <div id="homepage-investive-realestate-oryza-content-para-02">
              The project manages to strike the perfect mix between luxury &
              wilderness thanks to the presence of a magnificent lake on the
              property and the profusion of fruit & vegetable bearing plants on
              each plot. Here at Oryza Farmland, we’re here to assist you in
              selecting the best plot.ence. About 30-minute drive separates the
              community from Gachibowli and the city.
            </div>
            <div id="homepage-investive-realestate-oryza-content-sect-03">
              <div>Why Oryza ?</div>
              <div>Features</div>
              <div>Amenities</div>
              <div>Site Layout</div>
            </div>
          </div>
        </div>

        <div id="homepage-increase-security-profitability-section-wrap">
          <div id="homepage-increase-security-profitability-section-image-fill-wrap">
            <img
              src="./Home-img/project-bg01.png"
              alt=""
              id="homepage-increase-security-profitability-section-image"
            />
          </div>
          <div id="homepage-increase-security-profitability-section-title">
            We are here to increase the security and profitability of your
            investment
          </div>
          <div id="homepage-increase-security-profitability-section-content">
            Vihari Group has a history of completing projects effectively,
            establishing a reputation as one of the most reputable real estate
            companies in Telangana. We consider mutual trust and hospitality to
            be the cornerstones of every flourishing business.
          </div>
          <div id="homepage-increase-security-profitability-section">
            <div>Trust</div>
            <div>Dedication</div>
            <div>Customer Centric</div>
          </div>
        </div>

        <div id="homepage-passionate-about-work-section-wrap">
          <div id="homepage-passionate-about-work-section-image-fill-wrap">
            <img
              src="./Home-img/project-bg02.jpeg"
              alt=""
              id="homepage-passionate-about-work-section-image-fill"
            />
          </div>
          <hr id="homepage-passionate-about-work-section-divider" />
          <div id="homepage-passionate-about-work-section-title">
            We are passionate about work
          </div>
          <div id="homepage-passionate-about-work-section-content">
            Everyone adores that magical moment when a project provides them
            with a need-filling opportunity. It has a magical sense, and Vihari
            Projects is dedicated to providing you with this experience in
            choosing the lands of your choice.
          </div>
          <div id="homepage-passionate-about-work-section-grid-content-wrap">
            <div>
              <div className="homepage-passionate-about-work-section-grid-content-count">
                6 +
              </div>
              <div className="homepage-passionate-about-work-section-grid-content-text">
                Projects
              </div>
            </div>
            <div>
              <div className="homepage-passionate-about-work-section-grid-content-count">
                3500 +
              </div>
              <div className="homepage-passionate-about-work-section-grid-content-text">
                Happy Customers
              </div>
            </div>
            <div>
              <div className="homepage-passionate-about-work-section-grid-content-count">
                100 +
              </div>
              <div className="homepage-passionate-about-work-section-grid-content-text">
                Acres in Farmlands
              </div>
            </div>
            <div>
              <div className="homepage-passionate-about-work-section-grid-content-count">
                100 +
              </div>
              <div className="homepage-passionate-about-work-section-grid-content-text">
                Acres in Residential Lands
              </div>
            </div>
          </div>
        </div>
        <div id="homepage-advance-to-healthier-lifestyle-main-wrap">
          <div id="homepage-advance-to-healthier-lifestyle-headline">
            Advance to healthier lifestyle.
          </div>
          <Slider ref={slider01Ref} {...slider01_settings}>
            <div className="homepage-advance-to-healthier-lifestyle-slider-content-wrap">
              <img
                src="./Home-img/oryza.jpeg"
                alt="slider"
                className="homepage-advance-to-healthier-lifestyle-slider-image"
              />
              <div className="homepage-advance-to-healthier-lifestyle-slider-image-project-title">
                01
              </div>
              <div className="homepage-advance-to-healthier-lifestyle-slider-image-project-title">
                Oryza Farmlands
              </div>
            </div>
            <div className="homepage-advance-to-healthier-lifestyle-slider-content-wrap">
              <img
                src="./Home-img/oryza.jpeg"
                alt="slider"
                className="homepage-advance-to-healthier-lifestyle-slider-image"
              />
              <div className="homepage-advance-to-healthier-lifestyle-slider-image-project-title">
                02
              </div>
              <div className="homepage-advance-to-healthier-lifestyle-slider-image-project-title">
                Aushadha Nagari
              </div>
            </div>
            <div className="homepage-advance-to-healthier-lifestyle-slider-content-wrap">
              <img
                src="./Home-img/oryza.jpeg"
                alt="slider"
                className="homepage-advance-to-healthier-lifestyle-slider-image"
              />
              <div className="homepage-advance-to-healthier-lifestyle-slider-image-project-title">
                03
              </div>
              <div className="homepage-advance-to-healthier-lifestyle-slider-image-project-title">
                Sree Vanam
              </div>
            </div>
          </Slider>
        </div>

        <div id="homepage-finest-life-desires-section-wrap">
          <div id="homepage-finest-life-desires-section-headline">
            Your <span>finest</span> life <span id="homepage-finest-life-desires-section-headline-line-02-txt">desires to </span><span>grow</span>
          </div>
          <div
            className="homepage-finest-life-desires-section-content"
            id="homepage-finest-life-desires-section-content-para01"
          >
            Vihari Projects strikes the ideal balance between urban allure and
            natural beauty, combining community, connection, and convenience
            that will become the standard for luxurious living.
          </div>
          <div className="homepage-finest-life-desires-section-content">
            The right combination of amenities, accessibility, and natural
            beauty makes this area the gateway to Hyderabad’s west. There is
            nowhere better to construct your ideal farmhouse.
          </div>
          <div
            className="homepage-finest-life-desires-section-content"
            id="homepage-finest-life-desires-section-content-para03"
          >
            We believe that Living in the house of your dreams, close to
            everything that matters to you, and being surrounded by like-minded
            others in a tight-knit community is when true happiness can
            achieved.
          </div>

          <button id="homepage-finest-life-desires-section-button">
            Contact Now
          </button>
        </div>

        <div id="homepage-testimonial-section-wrap">
          <div id="homepage-testimonial-section-headline">
            Encouraging words from our customers
          </div>
          <Slider ref={slider02Ref} {...slider02_settings}>
            <div className="homepage-testimonial-slider-content-wrap">
              <div className="homepage-testimonial-slider-content">
                <div>
                  <img
                    src="./Home-img/vihari-logo.png"
                    alt=""
                    className="homepage-testimonial-slider-content-image01"
                  />
                </div>
                <div>
                  We recently bought property here. They are very
                  professional.The documents are clean and legally verified.
                  Services & quality are good. They are offering all the
                  amenities{" "}
                </div>
                <div>
                  <img
                    src="./Home-img/vihari-logo.png"
                    alt=""
                    className="homepage-testimonial-slider-content-image02"
                  />
                </div>
              </div>
              <div className="homepage-testimonial-slider-content-user-name">
                <BsDot className="homepage-testimonial-slider-content-user-name-dot-icon" />{" "}
                Mithila Nahata
              </div>
            </div>

            <div className="homepage-testimonial-slider-content-wrap">
              <div className="homepage-testimonial-slider-content">
                <div>
                  <img
                    src="./Home-img/vihari-logo.png"
                    alt=""
                    className="homepage-testimonial-slider-content-image01"
                  />
                </div>
                <div>
                  Good and awesome projects. Really it's connecting to both
                  nature and luxury style living. In short eco friendly
                  projects. And they are very much cooperative
                </div>
                <div>
                  <img
                    src="./Home-img/vihari-logo.png"
                    alt=""
                    className="homepage-testimonial-slider-content-image02"
                  />
                </div>
              </div>
              <div className="homepage-testimonial-slider-content-user-name">
                <BsDot className="homepage-testimonial-slider-content-user-name-dot-icon" />{" "}
                Ansuman Tripathy
              </div>
            </div>

            <div className="homepage-testimonial-slider-content-wrap">
              <div className="homepage-testimonial-slider-content">
                <div>
                  <img
                    src="./Home-img/vihari-logo.png"
                    alt=""
                    className="homepage-testimonial-slider-content-image01"
                  />
                </div>
                <div>
                  We recently bought property here. They are very
                  professional.The documents are clean and legally verified.
                  Services & quality are good. They are offering all the
                  amenities{" "}
                </div>
                <div>
                  <img
                    src="./Home-img/vihari-logo.png"
                    alt=""
                    className="homepage-testimonial-slider-content-image02"
                  />
                </div>
              </div>
              <div className="homepage-testimonial-slider-content-user-name">
                <BsDot className="homepage-testimonial-slider-content-user-name-dot-icon" />{" "}
                Mithila Nahata
              </div>
            </div>
          </Slider>
        </div>
      </div>
    );
}